import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as UserActions } from 'redux/domain/User';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';
import Customer from 'models/Customer';

import RegistrationForm from '../components/RegistrationForm';

/**
 * Allow the user register a new customer in eSTORIS.
 */
class RegistrationContainer extends React.Component {
	constructor() {
		super();

		this.switchModal = this.switchModal.bind(this);
		this.tokenSource = getCancelTokenSource();
	}

	componentWillReceiveProps(nextProps) {
		if (!nextProps.customer.isGuest) {
			// Customer has sucessfully logged in. Close the form.
			this.props.closeRegistration();
		}
	}

	componentWillUnmount() {
		// if a request is in progress stop it.
		cancelRequest(this.tokenSource);
	}

	/**
	 * Open the Login screen instead.
	 */
	switchModal() {
		this.props.closeRegistration();
		this.props.openLogin();
	}

	render() {
		const { isRegistering, register } = this.props;
		return (
			<RegistrationForm
				cancelToken={this.tokenSource.token}
				isRegistering={isRegistering}
				switchModal={this.switchModal}
				register={register}
			/>
		);
	}
}

RegistrationContainer.propTypes = {
	customer: PropTypes.instanceOf(Customer).isRequired,
	closeRegistration: PropTypes.func.isRequired,
	openLogin: PropTypes.func.isRequired,
	isRegistering: PropTypes.bool.isRequired,
	register: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
	const customer = state.user.get('customer');
	const isRegistering = state.user.get('isRegistering');
	return {
		customer,
		isRegistering,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators(UserActions, dispatch);

// for testing purposes
export { RegistrationContainer as RegistrationContainerClass };

// connect returns a function that accepts a component
export default connect(mapStateToProps, mapDispatchToProps)(RegistrationContainer);
